import {initReservPhonesEffects} from "../components/phones-effects";

export function initReservLanding() {
    if (!$('#reserv_landing').length) return;
    initReservPhonesEffects();
}
